import React, { useState, useEffect } from "react";
import {
  Grid,
  Select,
  FormControl,
  MenuItem,
  Card,
  InputLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import Fire_Panel from "../../assets/Images/Fire_Panel.png";
import Solar_Panel from "../../assets/Images/Solar_Panel.png";
import Exhaust_Fan from "../../assets/Images/Exhaust_Fan.png";
import Diesel_Generator from "../../assets/Images/Diesel_Generator.png";
import Ro_Plant from "../../assets/Images/RO_Plant.png";
import Server from "../../assets/Images/Server.png";
import VRF from "../../assets/Images/VRF.png";
import Water_Pump from "../../assets/Images/Water_Pump.png";
import Water_Leak from "../../assets/Images/Water Leak.png";
import Air_quality from "../../assets/Images/Air Quality.png";
import HYDROPNEUMATIC from "../../assets/Images/Hydropneumatic.png";
import LIFT from "../../assets/Images/LIft.png";
import Transformer from "../../assets/Images/Transformer.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  formControl: {
    width: "max-content",
    minWidth: "100%",
    backgroundColor: "#eeeef5",
    fontFamily: "Arial",
    height: "6vh",
  },
  paper1: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421",
    opacity: "1",
    borderRadius: "12px",
    height: "15vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 0",
  },
  cardHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
    marginTop: "1vh",
    font: "normal normal medium 17px/60px Bw Seido Round",
    opacity: "1",
    fontWeight: "bold",
    fontSize: "1.7vh",
    textAlign: "center",
  },
  select: {
    fontWeight: "bold",
    height: "6vh",
    borderRadius: "0.8vw",
    fontFamily: "Arial",
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      fontSize: "2vh",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root": {
      marginTop: "-2vh",
    },
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadius: "12px",
    opacity: "1",
  },
}));

export default function Eqp_Details() {
  const classes = useStyles();

  const [equipmentData, setEquipmentData] = useState({});
  const [availableTypes, setAvailableTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedDevice, setSelectedDevice] = useState("");

  useEffect(() => {
    api.floor.cpmGetDevData().then((res) => {
      const filteredTypes = Object.keys(res).filter(
        (key) => key !== "NONGL_SS_TFA"
      );
      setEquipmentData(res);
      setAvailableTypes(filteredTypes);
      setSelectedType(filteredTypes[0] || "");
      setSelectedDevice("");
    });
  }, []);

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
    setSelectedDevice("");
  };

  const handleDeviceChange = (e) => {
    setSelectedDevice(e.target.value);
  };

  const typeNameMap = {
    NONGL_SS_VRF: "Variable Refrigerant Flow",
    SS_EXHAUST_FAN: "Exhaust Fan",
    NONGL_SS_OVERHEAD_UNDERGROUND_TANK_LVL_SS: "Overhead Tank",
    NONGL_SS_DG: "Diesel Generator",
    NONGL_SS_PLUMBING_WATER_PUMP: "Plumbing Water Pump",
    NONGL_SS_WLD: "Water Leak Detector",
    NONGL_SS_SERVER_ROOM: "Server Room",
    NONGL_SS_TRANSFORMER: "Transformer",
    NONGL_SS_AIR_QUALITY_MONITOR_SYSTEM: "Air Quality Monitor System",
    NONGL_SS_LIFT: "Lift",
    NONGL_SS_RO_PLANT: "Reverse Osmosis Plant",
    NONGL_SS_FIRE: "Fire",
    NONGL_SS_SOLAR_PV_PLANT: "Solar PV Plant",
    NONGL_SS_UPS: "UPS",
    NONGL_SS_WTP: "Water Treatment Plant",
    NONGL_SS_HYDROPNEUMATIC_PLUMBING_PUMP: "Hydropneumatic Plumbing Pump",
  };

  const typeImageMap = {
    NONGL_SS_FIRE: Fire_Panel,
    NONGL_SS_SOLAR_PV_PLANT: Solar_Panel,
    SS_EXHAUST_FAN: Exhaust_Fan,
    NONGL_SS_DG: Diesel_Generator,
    NONGL_SS_RO_PLANT: Ro_Plant,
    NONGL_SS_SERVER_ROOM: Server,
    NONGL_SS_VRF: VRF,
    NONGL_SS_PLUMBING_WATER_PUMP: Water_Pump,
    NONGL_SS_WLD: Water_Leak,
    NONGL_SS_AIR_QUALITY_MONITOR_SYSTEM: Air_quality,
    NONGL_SS_HYDROPNEUMATIC_PLUMBING_PUMP: HYDROPNEUMATIC,
    NONGL_SS_LIFT: LIFT,
    NONGL_SS_TRANSFORMER: Transformer,
  };

  const devices = selectedType
    ? Object.entries(equipmentData[selectedType] || {}).sort((a, b) =>
        a[1].name.localeCompare(b[1].name)
      )
    : [];

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {/* Dropdowns */}
        <Grid container item xs={12} spacing={2}>
          {/* Equipment Type Dropdown */}
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="equipment-type-label">Equipment Type</InputLabel>
              <Select
                labelId="equipment-type-label"
                id="equipment-type"
                value={selectedType}
                onChange={handleTypeChange}
                label="Equipment Type"
                disableUnderline
                className={classes.select}
              >
                {availableTypes.map((typeKey) => (
                  <MenuItem key={typeKey} value={typeKey}>
                    {/* {typeNameMap[typeKey] || typeKey} */}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Device Dropdown */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={4}
            style={{ marginLeft: "1vw" }}
          >
            <FormControl variant="filled" className={classes.formControl}>
              <Select
                value={selectedDevice}
                onChange={handleDeviceChange}
                disableUnderline
                className={classes.select}
                displayEmpty
              >
                <MenuItem value="">All Devices</MenuItem>
                {devices.map(([deviceId, deviceInfo]) => (
                  <MenuItem key={deviceId} value={deviceId}>
                    {deviceInfo.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Device Cards */}
        <Grid container item xs={12} spacing={2} style={{ marginTop: "2vh" }}>
          {devices
            .filter(
              ([deviceId]) =>
                selectedDevice === "" || selectedDevice === deviceId
            )
            .map(([deviceId, deviceInfo]) => {
              const attributeCount = Object.keys(
                deviceInfo.Eqp_Attributes || {}
              ).length;
              const calculatedHeight = "44vh";

              return (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={deviceId}>
                  <Card
                    className={classes.paper}
                    style={{ height: calculatedHeight }}
                  >
                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      <Grid
                        item
                        xs={6}
                        style={{ textAlign: "left", marginLeft: "2vh" }}
                      >
                        <div
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "3vh",
                            marginLeft: "2vh",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: "1.2",
                            textAlign: "left",
                          }}
                        >
                          {deviceInfo.name}
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      {/* Square Box */}
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        {typeImageMap[selectedType] ? (
                          <img
                            src={typeImageMap[selectedType]}
                            // alt={typeNameMap[selectedType] || "Device Image"}
                            style={{
                              width: "10vw",
                              height: "25vh",
                              objectFit: "contain",
                              marginTop: "3.5vh",
                              marginLeft: "5vh",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "6vw",
                              height: "15vh",
                              marginTop: "3.5vh",
                              backgroundColor: "#cfd8dc",
                              border: "2px solid #0123b4",
                              borderRadius: "4px",
                              display: "flex",
                              marginLeft: "10vh",
                              justifyContent: "center",
                              alignItems: "center",
                              fontWeight: "bold",
                              color: "#0123b4",
                            }}
                          >
                            {/* Fallback Box */}
                          </div>
                        )}
                      </Grid>

                      {/* Attributes */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        style={{
                          overflowY:
                            Object.keys(deviceInfo.Eqp_Attributes || {})
                              .length > 4
                              ? "auto"
                              : "unset",
                          maxHeight:
                            Object.keys(deviceInfo.Eqp_Attributes || {})
                              .length > 4
                              ? "30vh"
                              : "unset",
                          paddingRight: "0.5vw",
                        }}
                      >
                        <Grid container spacing={1}>
                          {deviceInfo?.Eqp_Attributes &&
                            Object.entries(deviceInfo.Eqp_Attributes).map(
                              ([attrKey, attrValue]) => (
                                <Grid item xs={6} key={attrKey}>
                                  <Card className={classes.paper1}>
                                    <div className={classes.cardHeading}>
                                      {attrKey.replace(/_/g, " ")}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "2.5vh",
                                        color: "#0123B4",
                                        fontWeight: "bold",
                                        whiteSpace: "nowrap",
                                        marginBottom: "2vh",
                                      }}
                                    >
                                      {(() => {
                                        const val = attrValue.presentValue;

                                        if (attrKey.includes("AM_SS")) {
                                          return val === "active" || val === 1  || val === "1" 
                                            ? "Auto"
                                            : "Manual";
                                        } else if (attrKey.includes("RUN_SS")) {
                                          return val === "active" || val === 1  || val === "1" 
                                            ? "ON"
                                            : "OFF";
                                        } else if (attrKey.includes("On_Off")) {
                                          return val === "active" || val === 1  || val === "1" 
                                            ? "ON"
                                            : "OFF";
                                        } else if (
                                          attrKey.includes("Trip_SS_Alarm")
                                        ) {
                                          return val === "active" || val === 1  || val === "1" 
                                            ? "Tripped"
                                            : "Normal";
                                        } else if (
                                          attrKey.toLowerCase().includes("temp")
                                        ) {
                                          return !isNaN(parseFloat(val))
                                            ? `${parseFloat(val).toFixed(2)} °C`
                                            : val;
                                        } else if (
                                          attrKey ===
                                          "DG_Individual_ Day_Oil_Tnk_SS"
                                        ) {
                                          return !isNaN(parseFloat(val))
                                            ? `${parseFloat(val).toFixed(
                                                2
                                              )} Liters`
                                            : val;
                                        } else {
                                          return isNaN(parseFloat(val))
                                            ? val
                                            : parseFloat(val).toFixed(2);
                                        }
                                      })()}
                                    </div>
                                  </Card>
                                </Grid>
                              )
                            )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </div>
  );
}
